import { JSX } from "react";
import { Id } from "react-toastify";

import { toast } from "@4pace-cpq/core";
import { PropertyCommonProps } from "@plansoft-configuration-renderer/components";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";

export type AttributePropertyTextProps = PropertyCommonProps;

function toastHelper({
  value,
  type,
  timeout,
  toastId,
}: {
  value: string;
  type: string | undefined;
  timeout: number;
  toastId: string;
}): Id | undefined {
  switch (type) {
    case "warning":
      return toast.warning(value, {
        autoClose: timeout,
        toastId,
      });
    case "error":
      return toast.error(value, {
        autoClose: timeout,
        toastId,
      });
    case "success":
      return toast.success(value, {
        autoClose: timeout,
        toastId,
      });

    case "info":
    default:
      return toast.info(value, {
        autoClose: timeout,
        toastId,
      });
  }
}

export function CustomAttributePropertyText(
  props: AttributePropertyTextProps,
): JSX.Element {
  const attribute = useCsAttribute();
  const property = attribute.properties?.[props.propertyId];
  const autoCloseTimeout = 20000;
  let toastId: string = attribute.id + props.severity + property?.value;

  if (property?.value && props?.severity) {
    if (toast.isActive(toastId)) {
      toast.update(toastId);
    } else {
      toastHelper({
        value: property.value,
        type: props.severity,
        timeout: autoCloseTimeout,
        toastId,
      });
    }
  }

  return <></>;
  // const property = attribute.properties?.[props.propertyId];
  /*   return (
    <>
      <PropertyText {...props} property={property} />
    </>
  ); */
}
